import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ShieldOffIcon, RefreshCwIcon } from 'lucide-react';
export function ProcessSection() {
  return <section className="w-full bg-[#0f1629] py-20 md:py-28" data-id="element-193">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-195">
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#f0ebe3] mb-4" data-id="element-196">
            Cómo Funciona
          </h2>
          <p className="text-[#a0998e] text-lg" data-id="element-197">
            Tres pasos simples hacia tu recuperación
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-20" data-id="element-198">
          {/* Steps */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-199">
            {/* Step 1 */}
            <div className="flex gap-5" data-id="element-200">
              <div className="flex-shrink-0" data-id="element-201">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#c9a96e] to-[#d4a574] flex items-center justify-center" data-id="element-202">
                  <DownloadIcon className="w-7 h-7 text-[#0f1629]" data-id="element-203" />
                </div>
              </div>
              <div data-id="element-204">
                <div className="flex items-center gap-3 mb-2" data-id="element-205">
                  <span className="text-[#c9a96e] font-semibold text-sm" data-id="element-206">
                    PASO 1
                  </span>
                </div>
                <h3 className="font-['Playfair_Display'] text-xl font-bold text-[#f0ebe3] mb-2" data-id="element-207">
                  Descarga e Instalación
                </h3>
                <p className="text-[#a0998e] leading-relaxed" data-id="element-208">
                  Accede al PDF y al audio guía de inmediato en tu teléfono.
                  Disponible las 24 horas, incluso si son las 3 de la mañana.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex gap-5" data-id="element-209">
              <div className="flex-shrink-0" data-id="element-210">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#c9a96e] to-[#d4a574] flex items-center justify-center" data-id="element-211">
                  <ShieldOffIcon className="w-7 h-7 text-[#0f1629]" data-id="element-212" />
                </div>
              </div>
              <div data-id="element-213">
                <div className="flex items-center gap-3 mb-2" data-id="element-214">
                  <span className="text-[#c9a96e] font-semibold text-sm" data-id="element-215">
                    PASO 2
                  </span>
                </div>
                <h3 className="font-['Playfair_Display'] text-xl font-bold text-[#f0ebe3] mb-2" data-id="element-216">
                  Ejecuta el Blackout
                </h3>
                <p className="text-[#a0998e] leading-relaxed" data-id="element-217">
                  Sigue las instrucciones de blindaje digital para cerrar las
                  ventanas al pasado y proteger tu mente.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex gap-5" data-id="element-218">
              <div className="flex-shrink-0" data-id="element-219">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#c9a96e] to-[#d4a574] flex items-center justify-center" data-id="element-220">
                  <RefreshCwIcon className="w-7 h-7 text-[#0f1629]" data-id="element-221" />
                </div>
              </div>
              <div data-id="element-222">
                <div className="flex items-center gap-3 mb-2" data-id="element-223">
                  <span className="text-[#c9a96e] font-semibold text-sm" data-id="element-224">
                    PASO 3
                  </span>
                </div>
                <h3 className="font-['Playfair_Display'] text-xl font-bold text-[#f0ebe3] mb-2" data-id="element-225">
                  Reset Químico
                </h3>
                <p className="text-[#a0998e] leading-relaxed" data-id="element-226">
                  Sigue el protocolo de 72 horas para estabilizar tus
                  neurotransmisores y recuperar el control de tus pensamientos.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Product Image 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-227">
            <div className="relative" data-id="element-228">
              <div className="absolute inset-0 bg-gradient-to-r from-[#c9a96e]/10 to-[#d4a574]/10 blur-3xl rounded-full transform scale-110" data-id="element-229" />
              <img src="https://cdn.magicpatterns.com/uploads/84tNEF5vcoiXBDrHcmfTAq/heylloyd-image-1772237124839.png" alt="Breakup Blackout - Múltiples dispositivos mostrando el programa" className="relative z-10 w-full h-auto rounded-lg shadow-2xl" data-id="element-230" />
            </div>
          </motion.div>
        </div>

        {/* Proof / Stat Callout */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-r from-[#1a2342] to-[#1a2342]/80 border border-[#c9a96e]/30 rounded-2xl p-8 md:p-12 text-center" data-id="element-231">
          <div className="max-w-3xl mx-auto" data-id="element-232">
            <span className="text-[#c9a96e] text-6xl md:text-7xl font-bold font-['Playfair_Display']" data-id="element-233">
              90%
            </span>
            <p className="text-[#f0ebe3] text-xl md:text-2xl mt-4 leading-relaxed" data-id="element-234">
              En las primeras 24 horas de aplicar el Blackout, el{' '}
              <span className="text-[#c9a96e] font-semibold" data-id="element-235">
                90% de las usuarias
              </span>{' '}
              reportan una disminución drástica en la opresión del pecho y la
              capacidad de dormir más de 6 horas seguidas por primera vez desde
              la ruptura.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}